import { FC } from 'react'

import { LinkButton } from 'components/links'
import { Heading } from 'components/heading'
import { routes } from 'utils/routes'

import classes from './aut-header.module.css'

interface MainInfoProps {
  withBackToLogin?: boolean
  title: string
}

export const AutHeader: FC<MainInfoProps> = ({ withBackToLogin, title }) => {
  return (
    <header className={classes.section}>
      {withBackToLogin && (
        <LinkButton theme="goBack" className={classes.link} href={routes.partnerPortalLogin}>
          Return to login
        </LinkButton>
      )}

      <Heading theme="h2" component="h1" className={classes.header}>
        {title}
      </Heading>
    </header>
  )
}
